import { useEffect, useState } from "react";
import { useParams } from "react-router";

import { api } from "../../../../services/api";
import { WinningRegistrationUnits } from "../LoaderUnits";

interface WinningRegistration {
  id: string;
  slug: string;
  status: boolean;
  name: string;
  description: string;
  thanks_message: string;
  company_id: string;
  roulette_id: string;
  bonus_id: string;
  company: {
    name: string;
    slug: string;
  };
}

interface Franchise {
  radical: string;
}

interface UnifyQrcode {
  question_unity: string;
  form_message: string;
  list_view: string;
}

interface IResponse {
  winningRegistrations: WinningRegistration[];
  franchise: Franchise;
  unifyQrcode: UnifyQrcode;
}

export function IndexLoaderUnits() {
  const { unify_qrcode_id } = useParams();
  const [winningRegistrations, setWinningRegistrations] = useState<
    WinningRegistration[]
  >([]);
  const [unifyQrCode, setUnifyQrcode] = useState<UnifyQrcode>(
    {} as UnifyQrcode
  );
  const [franchise, setFranchise] = useState<Franchise>({} as Franchise);

  useEffect(() => {
    api
      .get<IResponse>(`/form/winningRegistration/units/${unify_qrcode_id}`)
      .then((response) => {
        setWinningRegistrations(response.data.winningRegistrations);
        setUnifyQrcode(response.data.unifyQrcode);
        setFranchise(response.data.franchise);
      });
  }, [unify_qrcode_id]);

  return (
    <WinningRegistrationUnits
      winningRegistrations={winningRegistrations}
      unifyQrCode={unifyQrCode}
      radical={franchise.radical}
    />
  );
}
